import React from 'react';
import { Link } from 'react-router-dom';
import { useScrollToTop } from '../hooks/useScrollToTop';

const Footer = () => {
  useScrollToTop();

  return (
    <footer style={{
      backgroundColor: '#f8f9fa',
      padding: '20px',
      marginTop: 'auto',
      borderTop: '1px solid #dee2e6',
      textAlign: 'center'
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '12px',
        flexWrap: 'wrap'
      }}>
        <Link
          to="/pricing"
          style={{
            color: '#6c757d',
            textDecoration: 'none',
            fontSize: '0.9rem',
            '&:hover': {
              color: '#0d6efd'
            }
          }}
        >
          Pricing
        </Link>
        <span style={{ color: '#6c757d' }}>|</span>
        <Link
          to="/terms-of-service"
          style={{
            color: '#6c757d',
            textDecoration: 'none',
            fontSize: '0.9rem',
            '&:hover': {
              color: '#0d6efd'
            }
          }}
        >
          Terms of Service
        </Link>
        <span style={{ color: '#6c757d' }}>|</span>
        <Link
          to="/privacy"
          style={{
            color: '#6c757d',
            textDecoration: 'none',
            fontSize: '0.9rem',
            '&:hover': {
              color: '#0d6efd'
            }
          }}
        >
          Privacy Policy
        </Link>
        <span style={{ color: '#6c757d' }}>|</span>
        <Link
          to="/terms"
          style={{
            color: '#6c757d',
            textDecoration: 'none',
            fontSize: '0.9rem',
            '&:hover': {
              color: '#0d6efd'
            }
          }}
        >
          Terms of Use
        </Link>
        <span style={{ color: '#6c757d' }}>|</span>
        <span style={{ color: '#6c757d', fontSize: '0.9rem' }}>
          © {new Date().getFullYear()} Pre Go Prep. A product of SB Enterprises Group LLC. All rights reserved.
        </span>
      </div>
    </footer>
  );
};

export default Footer; 